import styled from "styled-components";
import { WrapperContainer } from "../../components";
import { PageItem } from "../../components/PageSelector/styled";

export const PageSelectorWrapper = styled(WrapperContainer)`
  ${PageItem} {
    width: max-content;
  }
`;
